import React, { useState, useEffect, useRef } from "react";
import CaptionComponent from "../utils/CaptionComponent";
import { Container, Button, Card } from "react-bootstrap";

import Form from "react-bootstrap/Form";
import API from "../utils/api";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Error from "../Error";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Select from "react-select";
import InputGroup from "react-bootstrap/InputGroup";
import swal from "sweetalert";

const NuevoPrestamo = () => {
  var url = API.urlAPI;
  const urlCliente = url + "clientes";
  const UrlPrestamo = url + "prestamos";
  const urlModalidadPago = url + "modalidades-pago";

  const navigate = useNavigate();
  const [cuentaImporteTotal, setCuentaImporteTotal] = useState(0);
  const [cuentaImporteCuota, setcuentaImporteCuota] = useState(0);
  const [interesGanado, setinteresGanado] = useState(0);

  const interes = useRef(null);
  const importecredito = useRef(null);
  const interescuota = useRef(null);
  const diasgracia = useRef(null);
  const [error, setError] = useState(false);

  //Lista modalidades de pago
  const [modalidadPago, setModalidadPago] = useState([]);
  const [selectValue, setSelectValue] = useState("");
  const [selectModalidadPago, setselectModalidadPago] = useState("");
  const [MedioPago, setMedioPago] = useState("");
  const [cuota, setCuota] = useState("");

  const ContainerStyle = {
    boxShadow: "0px 0px 15px 8px rgba(0,0,0,0.1)",
  };

  const [options, setOptions] = useState([""]);
  const [optionsPago, setOptionsPago] = useState([""]);
  const [fecha, setFecha] = useState("");

  useEffect(() => {
    const getData = async () => {
      const arr = [];
      await axios.get(urlCliente).then((res) => {
        let result = res.data;
        result.map((user) => {
          return arr.push({
            value: user.IdCliente,
            label: user.Nombre + " " + user.Apellido,
          });
        });
        setOptions(arr);
      });
    };
    getData();
  }, []);

  useEffect(() => {
    const getModalidad = async () => {
      const arr = [];
      await axios.get(urlModalidadPago).then((res) => {
        let result = res.data;
        result.map((user) => {
          return arr.push({ value: user.Dias, label: user.Descripcion });
        });
        setOptionsPago(arr);
      });
    };
    getModalidad();
  }, []);

  const opcionesCuotas = Array.from({ length: 140 }, (_, i) => ({
  value: i + 1,
  label: String(i + 1),
}));

  const mediosPagos = [
    { value: "TR", label: "Transferencia" },
    { value: "EF", label: "Efectivo" },
  ];

  // Post Clientes
  const NuevoPrestamo = () => {
    const PostPrestamo = {
      IdCliente: selectValue.value,
      Cliente: selectValue.label,
      Modalidad: selectModalidadPago.value,
      TasaInteres: interes.current.value,
      ImporteCredito: importecredito.current.value,
      PorcentajeInteres: 0,
      CantCuotas: cuota,
      ImporteCuota: cuentaImporteCuota,
      importeTotal: cuentaImporteTotal,
      InteresPagos: interesGanado,
      DiasdeGracia: diasgracia.current.value,
      FechaAlta: fecha,
      medioPago: MedioPago.value,
    };

    const {
      IdCliente,
      Cliente,
      Modalidad,
      TasaInteres,
      ImporteCredito,
      CantCuotas,
      ImporteCuota,
      importeTotal,
      InteresPagos,
      PorcentajeInteres,
      DiasdeGracia,
      medioPago
    } = PostPrestamo;
    if (
      [
        IdCliente,
        Cliente,
        Modalidad,
        TasaInteres,
        ImporteCredito,
        CantCuotas,
        ImporteCuota,
        importeTotal,
        InteresPagos,
        PorcentajeInteres,
        DiasdeGracia,
        medioPago,
      ].includes("")
    ) {
      setError(true);
      console.log(selectValue);

      console.log(PostPrestamo);
      return;
    }
    setError(false);

    console.log(PostPrestamo);
    swal({
      title: "Deseas Crear el prestamo?",
      text:
        "Se creará un prestamo al cliente " +
        Cliente +
        " por un importe de $" +
        importeTotal +
        " a pagar en " +
        CantCuotas +
        " cuotas de $" +
        ImporteCuota +
        " ",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .post(UrlPrestamo, PostPrestamo)
          .then((response) => {
            const result = response.data;
            console.log(result);
            navigate("DetallePrestamo/" + response.data.Prestamo.IdPrestamo);
            console.log("Detalle Post: ", PostPrestamo);
            swal(
              "Prestamo " +
                response.data.Prestamo.IdPrestamo +
                " Creado Correctamente!",
              {
                icon: "success",
              }
            );
          })
          .catch((err) => {
            console.log(err);
            console.log(UrlPrestamo);
            console.log(PostPrestamo);
          });
      } else {
        swal("No se generará el Prestamo!");
      }
    });
  };

  function handleDecimalsOnValue(value) {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
    return value.match(regex)[0];
  }

  // Capturo lo que los usuarios escriben en el input y lo guardo en el estado
  const handleChange = (e) => {
    interes.current.value = handleDecimalsOnValue(interes.current.value);
    setinteresGanado(
      (Number(importecredito.current.value) * Number(interes.current.value)) /
        100
    );
    setCuentaImporteTotal(
      Number((importecredito.current.value * interes.current.value) / 100) +
        Number(importecredito.current.value)
    );
    setcuentaImporteCuota(cuentaImporteTotal / Number(cuota));
  };

  const handleChangeSelect = (e) => {
    setCuota(e.value);
    setcuentaImporteCuota(cuentaImporteTotal / Number(e.value));
    console.log(cuota);
  };

  return (
    <Container>
      <br></br>
      <Card style={ContainerStyle}>
        <Card.Header style={{ background: "#5589c4", color: "white" }}>
          <h3>Nuevo Crédito</h3>
        </Card.Header>
        <Card.Body>
          <Form>
            <Form.Group controlId="fecha">
              <Form.Label>Fecha:</Form.Label>
              <Form.Control
                type="date"
                value={fecha}
                onChange={(e) => setFecha(e.target.value)}
              />
              <br></br>
            </Form.Group>
            <Form.Group as={Col} controlId="medioPago">
                <Select
                  className="input-cont"
                  placeholder="Medio de pago"
                  options={mediosPagos}
                  isClearable={true}
                  isSearchable={true}
                  onChange={(e) => setMedioPago(e)}
                />
                <br></br>
              </Form.Group>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="clientes">
                <Select
                  className="input-cont"
                  placeholder="Cliente"
                  options={options}
                  isClearable={true}
                  isSearchable={true}
                  onChange={(e) => setSelectValue(e)}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="modalidad">
                <Select
                  className="input-cont"
                  placeholder="Modalidad de Pago"
                  options={optionsPago}
                  isClearable={true}
                  isSearchable={true}
                  onChange={(e) => setselectModalidadPago(e)}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="importecredito">
                <InputGroup>
                  <InputGroup.Text>$</InputGroup.Text>
                  <FloatingLabel
                    controlId="floatingInput"
                    label="Importe Credito"
                  >
                    <Form.Control
                      type="number"
                      name="importecredito"
                      placeholder="Ingresar el importe del credito"
                      onChange={handleChange}
                      min="1"
                      ref={importecredito}
                    />
                  </FloatingLabel>
                </InputGroup>
              </Form.Group>

              <Form.Group as={Col} controlId="interes">
                <InputGroup>
                  <InputGroup.Text>%</InputGroup.Text>
                  <FloatingLabel controlId="floatingTextarea2" label="Interes">
                    <Form.Control
                      type="number"
                      required="true"
                      name="interes"
                      placeholder="Ingresar Interes"
                      onChange={handleChange}
                      ref={interes}
                      min="1"
                      step=".01"
                    />
                  </FloatingLabel>
                </InputGroup>
              </Form.Group>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="cantCuotaas">
                  <Form.Label> </Form.Label>
                  <Select
                    className="input-cont"
                    placeholder="Cantidad de Cuotas"
                    options={opcionesCuotas}
                    isSearchable={true}
                    onChange={handleChangeSelect}
                  />
                </Form.Group>

    
                <Form.Group as={Col} controlId="diasgracia">
                  <Form.Label> </Form.Label>
                  <FloatingLabel
                    controlId="floatingTextarea5"
                    label="Días de Gracia"
                  >
                    <Form.Control
                      type="number"
                      name="diasgracia"
                      placeholder="Ingresar los dias de gracia"
                      min="1"
                      onChange={handleChange}
                      ref={diasgracia}
                    />
                  </FloatingLabel>
                </Form.Group>
              </Row>
            </Row>

            <Form.Group as={Col} controlId="importetotal">
              <Form.Label>Importe Total</Form.Label>
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                  type="number"
                  name="importetotal"
                  disabled="true"
                  onChange={handleChange}
                  value={cuentaImporteTotal}
                />
              </InputGroup>
            </Form.Group>
            <Form.Group as={Col} controlId="interescuota">
              <Form.Label>Importe Cuota</Form.Label>
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                  type="number"
                  name="importecuota"
                  disabled="true"
                  onChange={handleChange}
                  value={cuentaImporteCuota}
                />
              </InputGroup>
            </Form.Group>

            <Form.Group as={Col} controlId="interesganado">
              <Form.Label>Ganancia</Form.Label>
              <InputGroup>
                <InputGroup.Text>$</InputGroup.Text>
                <Form.Control
                  type="number"
                  name="interesganado"
                  disabled="true"
                  onChange={handleChange}
                  value={interesGanado}
                />
              </InputGroup>
            </Form.Group>

            <br></br>
            <div className="d-grid gap-2">
              <Button
                variant="success"
                style={{ boxShadow: "0px 6px 15px 8px rgba(0,0,0,0.1)" }}
                size="lg"
                onClick={() => NuevoPrestamo()}
              >
                Generar Prestamo
              </Button>
            </div>
            <br></br>
            <br></br>
            {error && (
              <Error>
                <p>Todos los campos son requeridos</p>
              </Error>
            )}
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default NuevoPrestamo;
